module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('error-reveal', {
    attrs: {
      "error": _vm.uierror
    }
  }), _vm._v(" "), _c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), (_vm.analytics) ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Felhasználó:\n        ")]), _vm._v(" "), _c('select-input', {
    attrs: {
      "options": _vm.users,
      "valueField": "id",
      "titleField": "displayName"
    },
    model: {
      value: (_vm.data.selectedUser),
      callback: function($$v) {
        _vm.$set(_vm.data, "selectedUser", $$v)
      },
      expression: "data.selectedUser"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.analytics && _vm.data.selectedUser) ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-6 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Engedélyezett oldalak:\n        ")]), _vm._v(" "), _c('channel-cards', {
    attrs: {
      "channels": _vm.channels
    },
    model: {
      value: (_vm.data.selectedChannels),
      callback: function($$v) {
        _vm.$set(_vm.data, "selectedChannels", $$v)
      },
      expression: "data.selectedChannels"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [(_vm.analytics && _vm.data.selectedUser) ? _c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mentés")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69e2a40c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/insights/Share.vue
// module id = 480
// module chunks = 2